export default __webpack_public_path__ + "static/media/cognexa.300dce90.png";